export default __webpack_public_path__ + "static/tooltip-info-do-light-c243fe55beeac943347908541ca7ad4bc46b8d6d2342021b6082e95bd309c188.png";